module.exports = __webpack_public_path__ + "img/mtn-logo.c81460aa.jpg";